export default {"src":"/_next/static/media/LiveClassIcon.1be0877e.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};